import {AppEvent} from '@esgi/events';

@AppEvent()
export class StorageFailureEvent {

}